// API

// axios
import axios from "axios";
import AppStore from "../stores/AppStore";
import { reaction } from "mobx";

const api_url = "https://bkapi.homestack.com/dash";
const base_api_url = "https://bkapi.homestack.com/";

let api_headers = {
  "X-STACK-ID": null
};

reaction(
  () => AppStore.api_key,
  () => {
    api_headers = {
      "X-API-KEY": AppStore.api_key
      //"X-STACK-ID": AppStore.stack_id
    };
  }
);

const Api = {
  // SSO
  accessToken: function(data, _success, _error) {
    axios
      .post(api_url + "/login/sso", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  // Log in
  login: function(data, _success, _error) {
    axios
      .post(api_url + "/login", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  // Log in via API key
  key: function(data, _success, _error) {
    axios
      .post(api_url + "/login/token", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  forgot: function(data, _success, _error) {
    axios
      .post(api_url + "/login/forgot", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  getProfile: function(_success, _error) {
    axios
      .get(api_url + "/user/profile", {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getPrefs: function(_success, _error) {
    axios
      .get(api_url + "/user/prefs", {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  savePrefs: function(data, _success, _error) {
    axios
      .post(
        api_url + "/user/prefs",
        { toggles: data },
        {
          headers: api_headers
        }
      )
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getStats: function(data, _success, _error) {
    axios
      .post(api_url + "/app/stats/", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getCSV: function(_success, _error) {
    let url = api_url + "/app/csv";

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getAgentsCSV: function(_success, _error) {
    let url = api_url + "/app/agents_csv";

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getUsers: function(limit, offset, sort, _success, _error, id) {
    let url = api_url + "/app/users";

    if (id) {
      url += "/" + id;
    }

    url += "?limit=" + limit + "&offset=" + offset + "&sort=" + sort;

    if (limit) {
      //url += "?page=" + page;
    }

    if (offset) {
      //
    }

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getPockets: function(_success, _error, id) {
    let url = api_url + "/app/pockets";

    if (id) {
      url += "/" + id;
    }

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getPocket: function(key, _success, _error, id) {
    let url = api_url + "/app/pocket/" + key;

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getAgents: function(limit, offset, sort, _success, _error, id) {
    let url = api_url + "/app/agents";

    if (id) {
      url += "/" + id;
    }

    if (limit) {
      url += "?limit=" + limit + "&offset=" + offset + "&sort=" + sort;
    } else if (sort) {
      url += "?sort=" + sort;
    }

    axios
      .get(url, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getAPIKey: function(_success, _error) {
    axios
      .get(api_url + "/app/api_key", {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  savePocket: function(data, _success, _error) {
    axios
      .post(api_url + "/app/pocket", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  changeAgent: function(userId, agentId, _success, _error) {
    axios
      .post(
        api_url + "/user/change_agent",
        {
          user_id: userId,
          agent_id: agentId
        },
        {
          headers: api_headers
        }
      )
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  deleteAgent: function(id, _success, _error) {
    axios
      .post(
        api_url + "/user/delete_agent",
        {
          id: id
        },
        {
          headers: api_headers
        }
      )
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  getApp: function(stack_id, _success, _error) {
    axios
      .get(base_api_url + "/app/" + stack_id, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        _error(error);
      });
  },

  uploadPocketPhoto: function(image, _success, _error) {
    const formData = new FormData();
    formData.append("file", new Blob([image]));

    axios
      .post(api_url + "/app/pocket_photo/", formData, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  uploadAvatar: function(agentId, image, _success, _error) {
    const formData = new FormData();
    /*formData.append("file", {
      uri: image,
      type: "image/jpeg",
      name: "avatar"
    });*/

    formData.append("file", new Blob([image]));

    axios
      .post(api_url + "/user/avatar/" + agentId, formData, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  // Delete avatar
  deleteAvatar: function(agentId, _success, _error) {
    axios
      .post(
        api_url + "/user/avatar/" + agentId,
        { delete: true },
        {
          headers: api_headers
        }
      )
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  updateAgentOrder: function(data, _success, _error) {
    let url = api_url + "/user/agent_order";

    axios
      .post(
        url,
        { order: data },
        {
          headers: api_headers
        }
      )
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  updateProfile: function(data, _success, _error, id) {
    let url = api_url + "/user/profile";

    if (id) {
      url += "/" + id;
    }

    axios
      .post(url, data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  createAgent: function(data, _success, _error) {
    axios
      .post(api_url + "/user/create_agent", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  createUser: function(data, _success, _error) {
    axios
      .post(api_url + "/user/create_user", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  },

  updateApp: function(data, _success, _error) {
    axios
      .post(api_url + "/app/update", data, {
        headers: api_headers
      })
      .then(function(response) {
        _success(response.data);
      })
      .catch(function(error) {
        if (error.response === undefined) {
          error.response = { data: { message: "Unable to reach server." } };
        }
        _error(error);
      });
  }
};

export default Api;
